import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import cName from "classnames";
import styles from './styles.module.scss';

import Wrapper from '@/components/wrapper';
import { getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export { getServerSideProps }

const Hotel: NextPage<IProps> = ({ menuDetail }: any) => {
  const router = useRouter();
  const t = useTranslations("visitor.hotel");

  const getList = useCallback(() => {
    const list = [];
    for (let i = 1; i <= 8; i++) {
      if (t(`list.item${i}.name`)) {
        list.push({
          img: t(`list.item${i}.img`),
          name: t(`list.item${i}.name`),
          level: Number(t(`list.item${i}.level`)),
          location: t(`list.item${i}.location`),
          type: t(`list.item${i}.type`),
          distance: t(`list.item${i}.distance`),
          free: t(`list.item${i}.free`),
          onePrice: Number(t(`list.item${i}.onePrice`)),
          twoPrice: Number(t(`list.item${i}.twoPrice`)),
          exPrice: t(`list.item${i}.exPrice`),
          traffic: [
            {
              site: t(`list.item${i}.traffic1site`),
              distance: t(`list.item${i}.traffic1distance`)
            },
            {
              site: t(`list.item${i}.traffic2site`),
              distance: t(`list.item${i}.traffic2distance`)
            },
            {
              site: t(`list.item${i}.traffic3site`),
              distance: t(`list.item${i}.traffic3distance`)
            },
          ],
        },)
      }
    }
    return list;
  }, [t]);

  const [list, setList] = useState(getList());

  useEffect(() => {
    setList(getList());
  }, [t]);

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <h2>{t('head.title')}</h2>
          <span className={styles.tip}>{t('head.tip')}</span>
          <p>
            {
              t.rich('head.text', {
                span: (chunks) => <span>{chunks}</span>,
                br: () => <br />,
              })
            }
          </p>
          <div className={styles.hotelList}>
            {
              list.map((item, index) => (
                <div className={styles.hotelItem} key={index}>
                  <div className={styles.top}>
                    <img src={item.img} alt={item.name} />
                    <div>
                      <h3>{item.name}</h3>
                      {
                        Array(item.level).fill(0).map((itm, idx) => (
                          <i key={idx}></i>
                        ))
                      }
                      <div>{t('list.trafficTitle')}</div>
                      {
                        item.traffic.map((child, idx) => (
                          child.site && <p key={idx}><span>{child.site}</span><span>{t('list.trafficText')}{child.distance}</span></p>
                        ))
                      }
                    </div>
                  </div>
                  <div className={styles.detail}>
                    <div><span>{t('list.location')}</span><p>{item.location}</p></div>
                    <div><span>{t('list.type')}</span><p>{item.type}</p></div>
                    <div>
                      <span>
                        {
                          t.rich('list.distance', {
                            br: () => <br />,
                          })
                        }
                      </span>
                      <p>{item.distance}</p>
                    </div>
                    <div><span>{t('list.free')}</span><p>{item.free}</p></div>
                  </div>
                  <div className={styles.bottom}>
                    <div>
                      <p>{t('list.onePrice')}<span><i>{item.onePrice}</i></span> RMB{item.exPrice}</p>
                      <p>{t('list.twoPrice')}<span><i>{item.twoPrice}</i></span> RMB{item.exPrice}</p>
                    </div>
                    <div className={styles.btn}>{t('list.btn')}</div>
                  </div>
                </div>
              ))
            }
          </div>
          {
            router.locale == 'cn' &&
            <div className={styles.foot}>
              <span className={styles.tip}>{t('foot.tip')}</span>
              <p>
                {
                  t.rich('foot.text', {
                    span: (chunks) => <span>{chunks}</span>,
                    spanred: (chunks) => <span style={{ color: 'red', fontWeight: 500 }}>{chunks}</span>,
                    br: () => <br />,
                  })
                }
              </p>
            </div>
          }
        </div>
      </Wrapper>
    </div>
  );
};

export default Hotel;
